import { useSelector } from 'react-redux'
import { selectMerchant } from 'selectors/merchant'

export default function useCurrentMerchant() {
  return useSelector(state =>
    //@ts-ignore
    selectMerchant(state, state.auth.current_merchant_id)
  )
}

export function useMerchantFeedbackEnabled() {
  const merchant = useCurrentMerchant()

  return merchant?.feedback_enabled ?? false
}
